import React from 'react'

// Styled Components
import { FullPage, Header, Paragraph, Link } from './PageNotFound.styles'

const PageNotFound = () => (
    <FullPage>
        <Header>Page not found</Header>
        <Paragraph>
            Sorry, we couldn't find the page you were looking for.{' '}
            <Link to="/">Click here to go home.</Link>
        </Paragraph>
    </FullPage>
)

export default {
    component: PageNotFound
}



// WEBPACK FOOTER //
// ./src/pages/PageNotFound.js